import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import StockManagementSubTab from "./SubTabs/StockManagementSubTab.jsx";
import StockSellerboardReports from "./SubTabs/StockSellerboardReports";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const SellerboardTab = () => {
  const [stockSubTab, setStockSubTab] = useState(0);

  const handleStockSubTabChange = (event, newValue) => {
    setStockSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={stockSubTab}
              onChange={handleStockSubTabChange}
              aria-label="stock tabs"
            >
              <Tab label="Management" />
              <Tab label="Sellerboard Reports" />
            </Tabs>
          </Box>

          <TabPanel value={stockSubTab} index={0}>
            <StockManagementSubTab />
          </TabPanel>

          <TabPanel value={stockSubTab} index={1}>
            <StockSellerboardReports />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SellerboardTab;
